import { isOpenInApp } from "@repo/shared-utils/pwa-utils";
import DescriptionUtil from "./DescriptionUtil";

interface DescriptionWithColumnsProps {
  id: string;
  heading: string;
  informationText: string;
  description: string;
  isTwoColumn: boolean;
  hideOnLoggedIn?: boolean;
  customClass?: string;
  showOnApp?: string;
}

export default function DescriptionWithColumns({
  id,
  heading,
  informationText,
  description,
  isTwoColumn,
  hideOnLoggedIn = false,
  customClass,
  showOnApp,
}: DescriptionWithColumnsProps) {
  if (isOpenInApp() && showOnApp !== "true") {
    return null;
  }

  return (
    <section
      id={id}
      className={`description-with-columns max-w-[1040px] pb-3 ${customClass ?? ""}`}
    >
      {/* Heading */}
      <h2 className="description-with-columns__heading font-medium text-[18px] text-[#1a1a1a]">
        {heading}
      </h2>

      {/* Information Text */}
      {informationText && (
        <div
          className="description-with-columns__info pt-2 pb-2 text-[#4d4d4d] text-[14px] leading-5 min-[1025px]:text-[16px] min-[1025px]:leading-6 [&_a]:text-[#ff6700]"
          dangerouslySetInnerHTML={{ __html: informationText }}
        />
      )}

      {/* Description Columns */}
      {description && (
        <div
          className={
            isTwoColumn
              ? "min-[1025px]:flex min-[1025px]:gap-4"
              : "min-[1025px]:flex min-[1025px]:gap-3"
          }
          dangerouslySetInnerHTML={{ __html: description }}
        />
      )}

        <DescriptionUtil targetId={id} hideOnLoggedIn={hideOnLoggedIn} />
      </section>
  );
}